namespace TabAurous.Common {
    export enum GenderType {
        Male = 1,
        Female = 2,
        TransGender = 3
    }
    Serenity.Decorators.registerEnumType(GenderType, 'TabAurous.Common.GenderType', 'HR.Gender');
}
